<script setup>
import { useI18n } from 'vue-i18n'

const props = defineProps({
  message: {
    type: String,
    default: () => useI18n().t('common.loading')
  }
})
</script>

<template>
  <div class="text-center py-8 loading-container">
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    />
    <p class="text-h6 mt-4">{{ message }}</p>
  </div>
</template>


<style scoped>
.loading-container {
  min-height: 400px;
}
</style>